/* WAD Noir — favorites saved in this browser */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function L(k, d) { var s = window.theme && window.theme.strings; return (s && s[k]) || d; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  var lastFocus = null;
  function openPanel(el) { if (!el) return; lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = el.querySelector('button, a'); if (f) setTimeout(function () { f.focus(); }, 50); }
  function closePanel(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }

  /* Favorites (saved in this browser) */
  var WKEY = 'wad-favorites';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} renderWish(); }
  var wishDrawer = $('#WishlistDrawer');
  function renderWish() {
    var list = wishGet();
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.classList.toggle('is-empty', list.length === 0); });
    $$('[data-wish-toggle]').forEach(function (b) {
      var on = list.some(function (i) { return i.handle === b.getAttribute('data-handle'); });
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? L('removeFav', 'Remove from favorites') : L('saveFav', 'Save to favorites'));
    });
    var body = $('[data-wish-items]'); if (!body) return;
    if (!list.length) { body.innerHTML = '<p class="drawer__empty">' + esc(L('favEmpty', 'No favorites yet. Tap the bookmark on any product to save it here.')) + '</p>'; return; }
    body.innerHTML = list.map(function (i) {
      return '<div class="line"><a class="line__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="line__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a><span class="line__variant">' + esc(i.price) + '</span>' +
        '<button type="button" class="line__remove line__remove--wish" data-wish-remove="' + esc(i.handle) + '">' + esc(L('remove', 'Remove')) + '</button></div><div></div></div>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var tog = t.closest('[data-wish-toggle]');
    if (tog) {
      var h = tog.getAttribute('data-handle'), list = wishGet();
      var idx = list.findIndex(function (i) { return i.handle === h; });
      if (idx > -1) list.splice(idx, 1);
      else list.unshift({ handle: h, title: tog.getAttribute('data-title'), url: tog.getAttribute('data-url'), price: tog.getAttribute('data-price'), image: tog.getAttribute('data-image') });
      wishSet(list); return;
    }
    if (t.closest('[data-open-wishlist]')) { renderWish(); openPanel(wishDrawer); return; }
    if (t.closest('[data-close-wishlist]')) { closePanel(wishDrawer); return; }
    var rm = t.closest('[data-wish-remove]');
    if (rm) { wishSet(wishGet().filter(function (i) { return i.handle !== rm.getAttribute('data-wish-remove'); })); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wishDrawer && wishDrawer.classList.contains('is-open')) closePanel(wishDrawer); });
  renderWish();

  /* Close the language panel on outside click / Escape */
  document.addEventListener('click', function (e) { $$('[data-lang][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('[data-lang][open]').forEach(function (d) { d.removeAttribute('open'); }); });

  /* Category tabs: filter the grid on the same page */
  $$('[data-cat-tabs]').forEach(function (nav) {
    var grid = nav.parentNode.querySelector('[data-cat-grid]'); if (!grid) return;
    var items = $$('.cat-item', grid), empty = nav.parentNode.querySelector('[data-cat-empty]');
    var btns = $$('.cat-tabs__btn', nav);
    function apply(btn, instant) {
      btns.forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var key = btn.getAttribute('data-cat'), match = (btn.getAttribute('data-match') || '').split(/\s+/).filter(Boolean);
      var shown = 0;
      items.forEach(function (it) {
        var cats = it.getAttribute('data-cats') || '';
        var ok = key === 'all' || match.some(function (m) { return cats.indexOf(' ' + m + ' ') > -1; });
        if (ok) shown++;
        if (instant) { it.hidden = !ok; return; }
        if (ok) { it.hidden = false; requestAnimationFrame(function () { it.classList.remove('is-hiding'); }); }
        else { it.classList.add('is-hiding'); setTimeout(function () { if (it.classList.contains('is-hiding')) it.hidden = true; }, 300); }
      });
      if (empty) empty.hidden = shown > 0;
      if (history.replaceState) history.replaceState(null, '', key === 'all' ? location.pathname + location.search : '#' + key);
    }
    nav.addEventListener('click', function (e) { var b = e.target.closest('.cat-tabs__btn'); if (b) apply(b); });
    var start = location.hash && nav.querySelector('[data-cat="' + location.hash.slice(1).replace(/"/g, '') + '"]');
    if (start) apply(start, true);
  });

  /* Hover: every product photo frame tilts toward the cursor (no view switching) */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (fine && !calm) {
    var SEL = '.card__media, .coll-card__media, .product__main-media, .product__thumb, .ptile__cell, .pmini__img';
    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest(SEL); if (!el) return;
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.classList.add('is-tilting');
      el.style.setProperty('--ry', ((x - 0.5) * 16).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
    });
    document.addEventListener('pointerout', function (e) {
      var el = e.target.closest && e.target.closest(SEL); if (!el || el.contains(e.relatedTarget)) return;
      el.classList.remove('is-tilting');
      el.style.removeProperty('--ry'); el.style.removeProperty('--rx');
    });
  }
})();
